import React from 'react';
import ReactDOM from 'react-dom';

import { UpdatePhotoEvents } from '../common/events/event-declarations';
import { builderDispatch } from '../../_utils/ui';

export default class InvalidDeliveryOptionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nextDeliveryOption: null,
      printFinish: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.builderDispatchToken = builderDispatch.register((payload) => {
      switch (payload.type) {
        case UpdatePhotoEvents.SHOW_INVALID_DELIVERY_OPTION_MODAL:
          const { nextDeliveryOption, printFinish, onContinue } = payload;

          this.setState(
            {
              nextDeliveryOption,
              printFinish,
            },
            () => {
              this.onContinue = onContinue;
              this.open();
            },
          );
          break;
      }
    });
  }

  componentDidMount() {
    $(ReactDOM.findDOMNode(this)).modal({
      show: false,
    });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  }

  open() {
    $(ReactDOM.findDOMNode(this)).modal('show');
  }

  handleContinue = () => {
    if (this.onContinue) {
      this.onContinue();
    }
  };

  render() {
    const { printFinish, nextDeliveryOption } = this.state;

    return (
      <div className="modal fade">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-heading">
              <h4 className="modal-title">
                Currently selected delivery method is not available
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>
                {printFinish?.title || 'The current finish'} prints are not
                available for this delivery method.
              </p>
              <p>
                Click{' '}
                {nextDeliveryOption &&
                  'Accept to switch to an available delivery method, or '}
                Cancel to stay with this finish type.
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-link btn-underline"
                type="button"
                data-dismiss="modal">
                Cancel
              </button>
              {nextDeliveryOption && (
                <button
                  className="btn btn-primary"
                  type="button"
                  data-dismiss="modal"
                  onClick={this.handleContinue}>
                  Accept
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
